//@flow
import React, { Component } from 'react';
import { connect } from 'react-redux';

import DescriptionEditor from '../Editors/Description';

import DescriptionViewer from '../Viewers/Description';

type props = {
  description: string,
  isActiveEditor: boolean,
};
class Description extends Component<props> {
  static defaultProps = {
    description: '',
  };

  render() {
    const { description, isActiveEditor } = this.props;
    return isActiveEditor ? (
      <DescriptionEditor description={description} />
    ) : (
      <DescriptionViewer description={description} />
    );
  }
}

const mapStateToProps = ({ trekOverview }) => ({
  isActiveEditor: trekOverview.activeEditor === 'DescriptionEditor',
});

export default connect(mapStateToProps)(Description);



// WEBPACK FOOTER //
// ./src/components/TrekDetail/DayOverview/Description.jsx